import formName from 'constants/formName'
import { actions } from 'data'
import { call, put } from 'redux-saga/effects'

import { goToStep } from './common'

export default function* preIdvStep() {
  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))
  yield call(goToStep, 'veriff')
}
